import initializeSdk from './sdk/umdLoader';

let sdkInstance = null;
let sdkLongId = "";

export const createSdk = async ( onSdkError ) => {
	const listUrlInput = document.getElementById( window.PayoneerData.listUrlContainerId );
	if ( !listUrlInput ) {
		throw new Error( 'No list-url input present, cannot create SDK instance' );
	}

	const {
		listIdAttribute,
		listEnvAttribute,
		websdkStyles: styles
	} = window.PayoneerData;

	const env = listUrlInput.getAttribute( listEnvAttribute ),
		longId = listUrlInput.getAttribute( listIdAttribute );

	/**
	 * Always create a new sdk instance if the longId changed.
	 * Avoids having stale list-sessions lingering causing trouble.
	 */
	if ( !sdkInstance || sdkLongId !== longId ) {
		sdkInstance = await initializeSdk( {
			env,
			longId,
			onBeforeError: onSdkError,
			styles,
		} );
		sdkLongId = longId;
	} else {
		//Updating the longId will trigger a refresh, to (dis)allow certain drop-in components.
		sdkInstance.updateLongId(longId);
	}

	return sdkInstance;
};
